module.exports = __webpack_public_path__ + "static/media/moving.c4256d8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Services/moving.jpg
// module id = 88
// module chunks = 0